import { Injectable, OnDestroy, inject } from '@angular/core';
import { CategoryModel } from '../models/categories.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class CategoriesService implements OnDestroy {
    private httpService = inject(HttpService);

    categories$ = new BehaviorSubject<CategoryModel[] | false>(false);
    categoryTitle$ = new BehaviorSubject(null);
    private subscriptions = new Subscription();

    /**
     * Dispatch
     */
    dispatch(): void {
        this.subscriptions.add(
            this.httpService
                .getCategories(99999)
                .pipe(
                    // delay(0),
                    tap((categores) => this.categories$.next(categores)),
                )
                .subscribe(),
        );
    }

    /**
     * Destroy all pending subscritpions
     */
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
